module.exports = __webpack_public_path__ + "static/img/pete_pictgrid27_980x873.b402447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid27_980x873.jpg
// module id = AQJu
// module chunks = 0